module.exports = __webpack_public_path__ + "img/Shop-m.445007e2.gif";